import { TextAndImageProps } from '../utils';
import { EnumPublicPagesImage } from '../../../../utils/enums';
import { getPublicImageUrl } from '../../../../utils/helpers';

export const textsAndImagesDigitalContracts: TextAndImageProps[] = [
  {
    id: 'create-in-real-time',
    title: 'Create in Real Time',
    content:
      'Predefined fields let you quickly build your contract from the ground up - you only need to follow the terms and add details to finalize the process. Cooperate in real time and get inspired with industry standards for similar projects.',
    image: getPublicImageUrl(EnumPublicPagesImage.CreateInRealTimeSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of a contract review on spona',
  },
  {
    id: 'eliminate-legal-fees',
    title: 'Eliminate Legal Fees',
    content:
      'There is no need to get a lawyer to mediate the negotiations process - our contracts are fully legally binding. All you need is to agree to the terms and conditions stated in the contract and sign it.',
    image: getPublicImageUrl(EnumPublicPagesImage.EliminateLegalFeesSeller),
    contentOrder: 'imageThenText',
    alt: 'Illustration showing contract terms agreement on Spona platform.',
  },
  {
    id: 'sign-digitally',
    title: 'Sign Digitally',
    content:
      'No more printing and scanning your documents. Once you’re satisfied with your contract terms, your contract will be available for signing through DocuSign.',
    image: getPublicImageUrl(EnumPublicPagesImage.SignDigitallySeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration showing digital signage on Spona',
  },
  {
    id: 'transparent-editing',
    title: 'Transparent Editing',
    content:
      'Even after the contract has been signed, project milestones are fully editable through annexes. Whenever a change is made, the buyer will be notified to review and submit it. After signing your annex, all changes will be applied to your project dashboard.',
    image: getPublicImageUrl(EnumPublicPagesImage.TransparentEditingSeller),
    contentOrder: 'imageThenText',
    alt: 'Illustration of editing contracts on Spona platform',
  },
  {
    id: 'access-at-any-time',
    title: 'Access at any Time ',
    content:
      'All of your contracts and contract annexes are stored and available for review and download from your account dashboard. Both parties get equal access to signed contracts, promoting transparent communication.',
    image: getPublicImageUrl(EnumPublicPagesImage.AccessAtAnyTimeSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of reviewing and downloading contracts on Spona platform',
  },
];

export const textsAndImagesPaymentProcessing: TextAndImageProps[] = [
  {
    id: 'transparent-payments',
    title: 'Transparent Payments',
    content:
      'Predefined fields let you quickly build your contract from the ground up - you only need to follow the terms and add details to finalize the process. Cooperate in real time and get inspired with industry standards for similar projects.',
    image: getPublicImageUrl(EnumPublicPagesImage.TransparentPaymentsSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of the budget allocation  on Spona',
  },
  {
    id: 'stay-in-sync',
    title: 'Stay in Sync',
    content:
      'The buyer will be alerted when it’s time for them to make their payment, ensuring that they don’t lose track of their invoices. You will also receive notifications for every step of the process so you have the peace of mind of being completely up to date with your invoicing',
    image: getPublicImageUrl(EnumPublicPagesImage.StayInSyncSeller),
    contentOrder: 'imageThenText',
    alt: 'Notification on Spona',
  },
  {
    id: 'secure-processing',
    title: 'Secure Processing',
    content:
      'With Spona, you can be sure that your money is in safe hands. We are a guarantee for both parties and protect payment execution to make sure you get your payments on time.',
    image: getPublicImageUrl(EnumPublicPagesImage.SecureProcessingSeller),
    contentOrder: 'textThenImage',
    alt: 'Secured payments illustration',
  },
  {
    id: 'track-invoices',
    title: 'Transparent Transactions',
    content:
      'Both you and the buyer have an overview of all transactions with invoices available for reference and download on your account dashboards.',
    image: getPublicImageUrl(EnumPublicPagesImage.TransparentTransactionsSeller),
    contentOrder: 'imageThenText',
    alt: 'Illustration of transactions overview on Spona',
  },
  {
    id: 'get-insights',
    title: 'Get Insights',
    content:
      'Check your current and forecasted earnings across your current project (or multiple, if you’re handling more than one at the same time) to review your revenue immediately.',
    image: getPublicImageUrl(EnumPublicPagesImage.GetInsightsSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of a graph on Spona',
  },
];

export const textsAndImagesMilestonesAndTasks: TextAndImageProps[] = [
  {
    id: 'standardize-processes',
    title: 'Standardize Your Processes',
    content:
      'One platform for you, your buyers and all your task management. No need for multitasking or learning new tools: Spona is a powerful tool for both beginner and experienced managers.',
    image: getPublicImageUrl(EnumPublicPagesImage.StandardizeYourProcessesSeller),
    contentOrder: 'textThenImage',
    alt: 'illustration_Standardize Your Processes',
  },
  {
    id: 'share-progress',
    title: 'Share Your Progress',
    content:
      'Segmenting your milestones into smaller tasks and updating status progress automatically reflects on your milestones, letting you easily determine your short-term and long-term goal progress. Your activity is visible to the buyer, effortlessly keeping everyone on the same page.',
    image: getPublicImageUrl(EnumPublicPagesImage.ShareYourProgressSeller),
    contentOrder: 'imageThenText',
    alt: 'illustration_Share Your Progress',
  },
  {
    id: 'resolve-issues',
    title: 'Resolve Issues',
    content:
      'In case of a problem, notify the buyer immediately by flagging the associated issues. Handle roadblocks before they escalate and keep track of the impact they have on your work.',
    image: getPublicImageUrl(EnumPublicPagesImage.ResolveIssuesSeller),
    contentOrder: 'textThenImage',
    alt: 'illustration_Resolve Issues',
  },
  {
    id: 'complete-milestones',
    title: 'Complete Milestones',
    content:
      'Progressing your project is a seamless and intuitive process designed to facilitate information sharing in the most convenient way possible. Simply mark a milestone as ready for buyer review to start the payment process.',
    image: getPublicImageUrl(EnumPublicPagesImage.CompleteMilestonesSeller),
    contentOrder: 'imageThenText',
    alt: 'illustration_Complete Milestones',
  },
  {
    id: 'track-project-health',
    title: 'Track Project Health',
    content:
      'You don’t have to organize data yourself to get an overview into your progress. Our platform consolidates all major and minor updates to your tasks and milestones into your overall project health, visible to the buyer for quick reference.',
    image: getPublicImageUrl(EnumPublicPagesImage.TrackProjectHealthSeller),
    contentOrder: 'textThenImage',
    alt: 'illustration_Track Project Health',
  },
];

export const textsAndImagesCommunication: TextAndImageProps[] = [
  {
    id: 'one-platform',
    title: 'One Platform',
    content:
      'Get a direct line to buyers with Spona’s messaging tool. If you’re handling multiple projects at once, get the benefit of gathering all of your contacts in one place.',
    image: getPublicImageUrl(EnumPublicPagesImage.OnePlatformSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of integrated messaging on Spona',
  },
  {
    id: 'quick-updates',
    title: 'Quick Updates',
    content:
      'Reduce back-and-forth with our automated systems for project progress, task management and payments execution.',
    image: getPublicImageUrl(EnumPublicPagesImage.QuickUpdatesSeller),
    contentOrder: 'imageThenText',
    alt: 'Illustration of automated system for project progress on Spona',
  },
  {
    id: 'accessible-support',
    title: 'Accessible Support',
    content:
      'Reduce your waiting times and get quick solutions by messaging our support team at Spona.',
    image: getPublicImageUrl(EnumPublicPagesImage.AccessibleSupportSeller),
    contentOrder: 'textThenImage',
    alt: 'Support chat illustration od Spona',
  },
  {
    id: 'record-activities',
    title: 'Record Your Activities',
    content:
      'It’s easy for data to get lost when you’re using multiple sources of communication. Spona provides the answer to this problem - a digital record of all your messages, always accessible through your platform.',
    image: getPublicImageUrl(EnumPublicPagesImage.RecordYourActivitiesSeller),
    contentOrder: 'imageThenText',
    alt: 'Illustration of the digital record of Spona user’s data',
  },
];

export const textsAndImagesMonitorYourKPIs: TextAndImageProps[] = [
  {
    id: 'make-data-driven-decisions',
    title: 'Make Data-Driven Decisions',
    content:
      'Eliminate guesswork with detailed, user-friendly reports that let you know exactly how your project is progressing. Pinpoint your strong and weak points and fuel your improvement with Spona.',
    image: getPublicImageUrl(EnumPublicPagesImage.MakeDataDrivenDecisionsSeller),
    contentOrder: 'textThenImage',
    alt: 'illustration_Make Data-Driven Decisions',
  },
  {
    id: 'easy-resource-planning',
    title: 'Easy Resource Planning',
    content:
      'Improve your scheduling and team management by keeping track of your key metrics. Increase your efficiency and optimize your resource utilization across the board.',
    image: getPublicImageUrl(EnumPublicPagesImage.EasyResourcePlanningSeller),
    contentOrder: 'imageThenText',
    alt: 'illustration_Easy Resource Planning',
  },
  {
    id: 'track-your-progress',
    title: 'Clear Communication',
    content:
      'Stay aligned with your stakeholders, your internal team and the buyer while cutting down on meetings, phone calls and emails.',
    image: getPublicImageUrl(EnumPublicPagesImage.ClearCommunicationSeller),
    contentOrder: 'textThenImage',
    alt: 'illustration_Easy communication',
  },
  {
    id: 'consolidate-projects',
    title: 'Consolidate Your Projects',
    content:
      'Get all your project data in one place. Get a detailed overview of all activities on one project, or compare different projects (across one or multiple buyers) to gain powerful insights.',
    image: getPublicImageUrl(EnumPublicPagesImage.ConsolidateYourProjectsSeller),
    contentOrder: 'imageThenText',
    alt: 'illustration_Consolidate Your Projects',
  },
  {
    id: 'reduce-data-micromanagement',
    title: 'Reduce Data Micromanagement',
    content:
      'Instead of managing multiple data sources, view all your key insights on one platform. Export your reports to easily share them with your team and external partners. ',
    image: getPublicImageUrl(EnumPublicPagesImage.ReduceDataMicromanagementSeller),
    contentOrder: 'textThenImage',
    alt: 'Illustration of  reviewing key insights on Spona',
  },
];
